import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=b1f81a1e&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f81a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f81a1e')) {
      api.createRecord('b1f81a1e', component.options)
    } else {
      api.reload('b1f81a1e', component.options)
    }
    module.hot.accept("./Help.vue?vue&type=template&id=b1f81a1e&scoped=true&", function () {
      api.rerender('b1f81a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help.vue"
export default component.exports